
import Fuse from 'fuse.js'
import _ from 'lodash';
import React, { Component } from 'react';
import {Button} from "@material-ui/core";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import styled from 'styled-components';
import {grey} from "@material-ui/core/colors";
import { IconButton } from '@material-ui/core';
import CachedIcon from '@material-ui/icons/Cached';
import { ListProvider, ListContext } from 'core/ListProvider';
import { DateDisplay } from 'core/Display';
import OrderListItem from './ListItem';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';

const StyledDate = styled.div`
  font-weight: 500;
  height: 40px;
  padding-left: 7px;
  display: flex;
  align-items: center;

  span.total {
    font-weight: normal;
    margin-left: 10px;
    font-size: 12px;
    color: ${grey[900]};
  }
    
  span.order {
    margin-left: 10px;
    font-size: 12px;
    font-weight: normal;
  }
`;

export default class OrderListItems extends Component {

  static defaultProps = {
    pageSize: 200,
    url: 'order/list2',
    itemApiUrl: 'order',
    itemBasePath: '/order',
    ItemComponent: OrderListItem,
    listPath: '/order',
  }

  constructor(props) {
    super(props);

    this.state = {
      isOpen: props.date !== null
    };

    this.listContext = null;
  }

  reload = () => {
    if (this.listContext) {
      this.listContext.reload();
    }
  };

  reloadList = (context) => {
    context.setPageNumber(1);
  };

  toggleOpen = () => {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  searchItems = (items, phrase) => {
    if (!phrase)
      return items;

    const options = {
      includeScore: true,
      threshold: 0.3,
      shouldSort: false,
      keys: [
        'tractor_unit_display',
        'driver_display',
        'semi_trailer_display',
        'points.point.name',
        'client.name',
        'counterparty.name',
        'contact_person.name',
        'container_number',
        'description',
        'cargo_weight',
      ]
    };

    const fuse = new Fuse(items, options);
    let results = [];
    fuse.search(phrase).forEach(el => results.push(el.item));
    return results;
  }

  filterByClientPersonalManagers = (items, users) => {
    if (users && users.length > 0) {
      const usersId = users.map(item => item.id);
      items = _.filter(items, function(item) {
        return item.client === null ||
          item.client.personal_manager_id === null ||
          usersId.includes(item.client?.personal_manager_id)
      })
    }
    return items;
  }

  calculateTotalItems = (items) => {
    return _.filter(items, {order_status: {is_canceled: false}}).length;
  }

  render() {
    const { date, searchPhrase, clientPersonalManagers, pageSize, url, itemApiUrl, itemBasePath, ItemComponent, previewId, listPath, onPreview, onClosePreview, onItemsLoaded, itemProps } = this.props;
    const { isOpen } = this.state;

    let filter = {};
    if (date) {
      filter['date'] = date.format('YYYY-MM-DD');
    }
    else if (date === null) {
      filter['date_start__isnull'] = true;
    }

    return (
      <ListProvider
        url={url}
        filterDefaults={{
          page_size: pageSize,
          ...filter
        }}
        orderDefaults={{
          field: 'one_day_order',
          type: 'asc'
        }}
        onComplete={(provider, state) => {
          if (onItemsLoaded) {
            onItemsLoaded(state.items);
          }
        }}
      >
        <ListContext.Consumer>
          {context => {
            this.listContext = context;
            const { items, loading } = context;
            let searchedItems = this.searchItems(items, searchPhrase);
            searchedItems = this.filterByClientPersonalManagers(searchedItems, clientPersonalManagers);
            return (
              <React.Fragment>
                {(items.length > 0 || date !== null) && (
                  <React.Fragment>
                    <StyledDate>
                      {date !== null && (<DateDisplay value={date} format={'DD MMMM'}/>)}
                      {date === null && (
                        <Button
                          disabled={loading}
                          size={'small'}
                          onClick={() => this.toggleOpen()}
                          startIcon={isOpen ? <ArrowDropDownIcon/> : <ArrowDropUpIcon/>}
                        >
                          Без даты перевозки
                        </Button>
                      )}
                      <span className={'total'}>Всего: {this.calculateTotalItems(items)}</span>
                      <Button
                        size={'small'}
                        disabled={context.getOrderField('one_day_order') !== null}
                        onClick={() => context.setOrder('one_day_order')}
                        className={'ml-5'}
                      >
                        По умолчанию
                      </Button>
                      <Button
                        size={'small'}
                        disabled={context.getOrderField('one_day_order_schedule') !== null}
                        onClick={() => context.setOrder('one_day_order_schedule')}
                        className={'ml-5'}
                      >
                        По связкам
                      </Button>
                      <IconButton disabled={loading} size={'small'} className={'ml-10'}
                                  onClick={() => this.reloadList(context)}>
                        <CachedIcon/>
                      </IconButton>
                    </StyledDate>
                    {isOpen && (
                      <TableContainer>
                      <Paper elevation={3} variant="outlined">
                          <Table aria-label="simple table">
                            <TableBody>
                              {searchedItems.map((item, index) =>
                                <ItemComponent
                                  key={item.id}
                                  item={item}
                                  index={index}
                                  apiUrl={itemApiUrl}
                                  basePath={itemBasePath}
                                  previewId={previewId}
                                  listPath={listPath}
                                  onPreview={onPreview}
                                  onClosePreview={onClosePreview}
                                  {...itemProps}
                                />
                              )}
                            </TableBody>
                          </Table>
                        </Paper>
                      </TableContainer>
                    )}
                  </React.Fragment>
                )}
              </React.Fragment>
            )
          }}
        </ListContext.Consumer>
      </ListProvider>
    )
  }
}
